// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__IDgi6","descriptionTitle":"Description_descriptionTitle__IXhwM"};